import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

export type InputProps = {}

export type Variables = {
  mainReason: string[]
  rating?: string
  suggestions?: string
  email?: string
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

const SEND_FEEDBACK_MUTATION = gql`
  mutation sendFeedback(
    $mainReason: [String!]
    $rating: String
    $suggestions: String
    $email: String
  ) {
    sendFeedback(mainReason: $mainReason, rating: $rating, suggestions: $suggestions, email: $email)
  }
`

const withSendFeedbackMutation = graphql<InputProps, Response, Variables, ChildProps>(
  SEND_FEEDBACK_MUTATION,
  {
    name: 'sendFeedback',
  },
)

export default withSendFeedbackMutation
